import { vitalBannerWrapper } from "../components/hoc/";
import ManagerDashboard from "./MainDashboard";
import companyInfoComponent from "./companyInfo";
import companySetupComponent from "./CompanySetup";
import planSelectionComponent from "./PlanSelection";
import buildyourPlanComponent from "./buildyourPlan";
import UploadExcelComponent from "./uploadExcel";
import PaymentSummary from "./paymentSummary";
import Authorisation from "../components/hoc/authorisation";
import PrivateRoute from "../components/hoc/privateRoute";
import uploadCdExcel from "./uploadCdExcel";
import uploadPolicyNos from "./UploadPolicyNumbers";
import gmcPaymentSummary from "./GmcPaymentSummary";
import uploadRatechart from "./uploadRatechart";
import uploadPolicyDoc from "./UploadPolicyDocument";
import rateChart from "./rateChart";
import uploadDocument from "./uploadDocument";
import prePurchaseRecommendation from "./prePurchaseRecommendation";
import addDeleteEmoployee from "./addDeleteEmployee";
import thankYouPage from "./thankYouPage";
import signUp from "./signup";
import PublicWrapper from "../components/hoc/publicWrapper";
import forgetPassword from "./forgetPassword";
import uploadEndorsement from "./UploadEndorsementEdit";
// Plan Setup imports
import insuranceSetup from "./PlanSetup/InsuranceSetup";
import gmcSetup from "./PlanSetup/GmcSetup";
import viewCdBalance from "./ViewUpdateCd/ViewCdBalance";
import viewCdTable from "./ViewUpdateCd/ViewCdTable";
import gpaGtlSetup from "./PlanSetup/GpaGtlSetup";
import gmcRatechart from "./PlanSetup/GmcRatechart";
// Upload Document
import selectPlan from "./UploadDocument/SelectPlan";
import eCardPreview from "./CareDashboard/ECardPreview";
import eCardDownload from "./CareDashboard/ECardDownload";
import thankYouMessage from "./thankYouMessage";
//Flex setup
import Benefits from "./FlexSetup/Benefits";
import TPASetup from "./FlexSetup/TPA";
import GhiTPASetup from "./PlanSetup/TpaSetupPage";
import FlexGpaSetup from "./FlexSetup/SetupGpa";
import PricingSetup from "./FlexSetup/GhiPricing";
import AttributeSetup from "./FlexSetup/AttributeSetup";
import FlexUploadDocuments from "./FlexSetup/UploadDocuments";
import FlexDashboard from "./FlexSetup/Dashboard";
import FlexMasterDoc from "./FlexSetup/MasterDoc";
import FlexEmployeeSheet from "./FlexSetup/UploadEmployeeSheet";
import FlexErrorFile from "./FlexSetup/ErrorFile";
import FlexProductStatus from "./FlexSetup/ProductStatus";
import BulkProductUpload from "./FlexSetup/BulkProductUpload";
import FlexPendingStatus from "./FlexSetup/ErrorFile/PendingStatus";
import EnrolmentHistory from "./EnrolmentHistory";
import GradeSetup from "./GradeSetup";
import GradeSetupSummary from "./GradeSetup/GradeSummary";
// Universal Setup
import Insurer from "./UniversalSetup/Insurer";
import CoverageDoc from "./UniversalSetup/CoverageDoc";
import Wellness from "./v1/Wellness";
import BenefitSummary from "./v1/Wellness/BenefitSummary";

//corporate buffer
import CorporateBufferPreIssuanceComponent from "./UniversalSetup/CorporateBufer/CorporateBufferPreIssuance";

//universal product setup
import BenefitsComopnent from "./UniversalSetup/Benefits";
import PlanSetupComponent from "./UniversalSetup/PlanSetup";

//universal policy id upload
import ComonentChooseProductToUploadUHID from "./UniversalSetup/ChooseProductToUploadUHID";
import ComponentUploadPolicyId from "./UniversalSetup/UploadPolicyId";
import ComponentSuperTaskUploadagain from "./UniversalSetup/SuperTaskUploadAgain";

//uhiversal post issuance
import ComponentUploadPolicyIdPost from "./UniversalSetup/PostIssuanceUhidUpload";
import ComponentUpdateCorporateBuffer from "./UniversalSetup/UniversalCorporateBuffer/updateCorporateBuffer";
import ComponentViewCorporateBuffer from "./UniversalSetup/UniversalCorporateBuffer";

//universal employee data
import ComponentUploadEmployeeData from "./UploadEmployeeData";
import ComponentDataCollectionHistory from "./UniversalSetup/DataCollectionHistory";

//claim setup
import ComponentClaimSupport from "./ClaimSupport";

//get tast set
import ComponentPostGetTaskSet from "./PostGetTaskSet";
import ComponentErrorFileDownload from "./PostGetTaskSet/ErrorFileDownload";

//user profile
import ComponentUserProfile from "./UserProfile";
import ComponentChangePassword from "./ChangePassword";

// Utilities
import UtilitiesHomeComponent from "./Utilities";
import UtilitiesUHIDGenerator from "./Utilities/ClientIdGenerator";
//claim mis
import ComponentClaimDashboard from "./ClaimsMis/ClaimDashboard"
import ClaimsMis from "./Claims/Mis";
import ClaimsEmployeeDetail from "./Claims/EmployeeDetail";
import BenefitSetup from "./v1/Wellness/BenefitSetup";

//
import ProductExclusion from "./ProductExclusion"

export const ManagerDashBoardComponent = Authorisation(
  vitalBannerWrapper(ManagerDashboard)
);
export const companyInfo = Authorisation(companyInfoComponent);
export const companySetup = Authorisation(companySetupComponent);
export const planSelection = Authorisation(planSelectionComponent);
export const buildyourPlan = Authorisation(buildyourPlanComponent);
export const UploadExcel = Authorisation(UploadExcelComponent);
export const PaymentSummaryPage = Authorisation(PaymentSummary);
export const UploadCdExcel = Authorisation(uploadCdExcel);
export const UploadPolicyNos = Authorisation(uploadPolicyNos);
export const GmcPaymentSummary = Authorisation(gmcPaymentSummary);
export const UploadEndorsement = Authorisation(uploadEndorsement);
export const uploadPolicyDocPage = Authorisation(uploadPolicyDoc);
export const UploadRatechart = Authorisation(uploadRatechart);
export const RateChart = Authorisation(rateChart);
export const UploadDocument = Authorisation(uploadDocument);
export const PrePurchaseRecommendation = Authorisation(
  prePurchaseRecommendation
);
export const AddDeleteEmoployee = Authorisation(addDeleteEmoployee);
export const ThankYouPage = Authorisation(thankYouPage);
export const ThankYouMessage = Authorisation(thankYouMessage);
export const SignUp = PublicWrapper(signUp);
export const ForgetPassword = PublicWrapper(forgetPassword);

// Plan Setup
export const InsuranceSetup = Authorisation(insuranceSetup);
export const GmcSetup = Authorisation(gmcSetup);
export const GpaGtlSetup = Authorisation(gpaGtlSetup);
export const GmcRatechart = Authorisation(gmcRatechart);
export const WellnessComp = Authorisation(Wellness);

//CD Balance
export const ViewCdBalance = Authorisation(viewCdBalance);
export const ViewCdTable = Authorisation(viewCdTable);

// Upload Documents
export const SelectPlan = Authorisation(selectPlan);

// E-Card
export const ECardPreview = Authorisation(eCardPreview);
export const ECardDownload = Authorisation(eCardDownload);

// Flex Setup
export const FlexSetupBenefits = Authorisation(Benefits);
export const FlexSetupTPA = Authorisation(TPASetup);
export const GhiSetupTPA = Authorisation(GhiTPASetup);
export const FlexSetupGPA = Authorisation(FlexGpaSetup);
export const FlexPricingSetup = Authorisation(PricingSetup);
export const ProductAttribute = Authorisation(AttributeSetup);
export const FlexUploadDocument = Authorisation(FlexUploadDocuments);

export const FlexDashboardPage = Authorisation(FlexDashboard);
export const FlexMasterDocPage = Authorisation(FlexMasterDoc);
export const FlexEmployeeSheetUpload = Authorisation(FlexEmployeeSheet);
export const FlexError = Authorisation(FlexErrorFile);
export const FlexProductsOverview = Authorisation(FlexProductStatus);
export const BulkProductUploadPage = Authorisation(BulkProductUpload);
export const FlexPendingStatePage = Authorisation(FlexPendingStatus);

export const EnrolmentHistoryPage = Authorisation(EnrolmentHistory);
export const GradeSetupPage = Authorisation(GradeSetup);
export const GradeSetupSummaryPage = Authorisation(GradeSetupSummary);

//corporate buffer
export const CorporateBufferPreIssuance = Authorisation(
  CorporateBufferPreIssuanceComponent
);
// Universal Setup
export const InsurerPage = Authorisation(Insurer);
export const CoverageDocPage = Authorisation(CoverageDoc);

//universal setup
export const BenefitSelect = Authorisation(BenefitsComopnent);
export const PlanSetup = Authorisation(PlanSetupComponent);

// UTILITIES
export const UtilitiesHome = Authorisation(UtilitiesHomeComponent);
export const UtilitiesUhidGenerator = Authorisation(UtilitiesUHIDGenerator);

//universla policy id upload
export const ChooseProductToUploadUHID = Authorisation(
  ComonentChooseProductToUploadUHID
);
export const UploadPolicyId = Authorisation(ComponentUploadPolicyId);
export const SuperTaskUploadagain = Authorisation(
  ComponentSuperTaskUploadagain
);

//uhiversal post issuance
export const PostIssuanceUhidUpload = Authorisation(
  ComponentUploadPolicyIdPost
);
export const UpdateCorporateBuffer = Authorisation(
  ComponentUpdateCorporateBuffer
);
export const UniversalCorporateBffer = Authorisation(
  ComponentViewCorporateBuffer
);

//universal employee data upload
export const UploadEmployeeData = Authorisation(ComponentUploadEmployeeData);
export const DataCollectionHistory = Authorisation(
  ComponentDataCollectionHistory
);

//claim support
export const ClaimSupport = Authorisation(ComponentClaimSupport);

//gettaskset post issuance
export const PostGetTaskSet = Authorisation(ComponentPostGetTaskSet);
export const ErrorFileDownload = Authorisation(ComponentErrorFileDownload);

//user profile
export const UserProfile = Authorisation(ComponentUserProfile);
export const ChangePassword = Authorisation(ComponentChangePassword);

//cliam mis
export const ClaimDashboard = Authorisation(ComponentClaimDashboard)
export const ClaimsMisPage = Authorisation(ClaimsMis);
export const ClaimsEmployeeDetailPage = Authorisation(ClaimsEmployeeDetail);
export const BenefitSetupComp = Authorisation(BenefitSetup);
export const BenefitSummaryComp = Authorisation(BenefitSummary);

// product exclusion
export const ProductExclusionPage = Authorisation(ProductExclusion);

export { default as careDashboard } from "./careDashboard";
export { default as CaredashboardList } from "./CareDashboard/CareDashboardList";
